module.exports = __webpack_public_path__ + "d2cef4d55918b8a6716572f550d63a1c.pdf";